import React, { Component } from 'react'
import './Stores.css'
import { connect } from 'react-redux'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
const offlineImage = require('../../images/connection_offline.png')
const OnlineImage = require('../../images/connection_online.png')
class Device extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      disableRemove: false
    }
    this.handleViewDevice = this.handleViewDevice.bind(this)
    this.renderRows = this.renderRows.bind(this)
    this.enableRemoveBtn = this.enableRemoveBtn.bind(this)
    this.checkRemotePermission = this.checkRemotePermission.bind(this)
  }
  handleViewDevice (id) {
    this.props.viewDevice(id)
  }
  enableRemoveBtn (e) {
    return e.currentTarget.checked ? this.setState({ disableRemove: true }) : this.setState({ disableRemove: false })
  }

  checkRemotePermission (data) {
    return (
      <td>
        <img src={OnlineImage} className={'cstat ' + (data.Device_IsActive ? '' : 'hidden')} alt='Device Online' />
        <img src={offlineImage} className={'cstat ' + (!data.Device_IsActive ? '' : 'hidden')} alt='Device Offline' />
        <span> {data.Device_IsActive === 0 ? 'Offline' : 'Online'}</span></td>
    )
  }
  // Renders the data.
  renderRows () {
    const { language } = this.state
    let row = this.props.stores.Device_Details
    let self = this
    row = row.filter(function (el) {
      if (self.props.device) {
        if (self.props.device === 'ION') {
          return el.Device_Name !== 'CIB' && el.Device_Name !== 'EOS' && el.Device_Name !== 'ZOOM'
        } else if (self.props.device === 'EOS') {
          return el.Device_Name !== 'CIB' && el.Device_Name !== 'ION' && el.Device_Name !== 'ZOOM'
        }
      }
    })
    let rows = row.map((data, index) => {
      return (
        <tr className='device-row-data'>
          <td className='device-checkbox'>
            <input type='checkbox' name='checkbox' id='idname' className={'device-check-input ' + (this.props.storeModelPopupIsAdmin ? 'show' : 'hide')} onChange={this.enableRemoveBtn} />
          </td>
          <td >{data.Device_SettingVersion}</td>
          <td >{data.Device_SerialNumber}</td>
          {this.checkRemotePermission(data)}
          <td onClick={() => this.handleViewDevice(data.Device_UID)}><a className='device-view-link'> {t[language].settingsStoresViewDetails} </a></td>
        </tr>
      )
    })
    return rows
  }
  // Main render function.
  render () {
    const { language } = this.state
    return (
      <div>
        <h4 className='header'> { this.props.device === 'ION' ? t[language].settingsStoresRegisteredION : this.props.device === 'EOS' ? t[language].settingsStoresRegisteredEOS : '' }</h4>
        <table className='device-list-table'>
          <tbody>
            <tr className='theader'>
              <th />
              <th>{t[language].settingsStoresSystemVersion}</th>
              <th>{t[language].settingsStoresSerialNumber}</th>
              <th>{t[language].settingsStoresSystemStatus}</th>
              <th />
            </tr>
            {this.renderRows()}
          </tbody>
        </table>
        <div className={'remove-sys ' + (this.props.storeModelPopupIsAdmin ? 'show' : 'hide')}>
          <a className='remove-system-device' href=''>
            <span className={'remove-device-item ' + (this.state.disableRemove ? 'disable-remove-device' : '')}>{t[language].RemoveSystem}</span>
          </a>
        </div>
      </div>
    )
  }
}
// Setting the state from redux store.
function mapStateToProps (state) {
  return {
    stores: state.StorePopupDetails.storePopupDetails
  }
}

export default connect(mapStateToProps)(Device)



// WEBPACK FOOTER //
// ./src/components/Stores/Device.js